// components/Jumbotron.tsx
"use client";
import { Flex, Box, Show } from "@chakra-ui/react";
import background_image from "@public/pexels-francesco-ungaro-998641-2.webp";
import Navbar from "./Navbar";

const Jumbtron = ({
  children,
  background,
  height = "400",
  backgroundImageHeight = "100%",
  px = {
    base: "25px",
    sm: "35px",
    md: "40px",
    lg: "60px",
    xl: "60px",
    "2xl": "20%",
  },
  opacity = "1",
}: any) => {
  return (
    <Flex w="100%" direction="column">
      <Flex
        opacity={0.9}
        h={{ base: "290px", md: height }}
        direction="column"
        backgroundRepeat="no-repeat"
        bg={background ? background : "#16181F"}
        position="relative"
      >
        {/* Show Box when Desktop, >= 768px */}
        <Show above="md">
          <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height={backgroundImageHeight}
            backgroundImage={background_image.src}
            backgroundSize="contain"
            opacity={opacity}
            mixBlendMode="lighten"
            zIndex={0}
          />
        </Show>
        <Navbar />
        <Flex zIndex={1} px={px} justify="center">
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Jumbtron;
